import { render, staticRenderFns } from "./Top10KundenBereichDrittUmsatz.vue?vue&type=template&id=77ef9c92&"
import script from "./Top10KundenBereichDrittUmsatz.vue?vue&type=script&lang=ts&"
export * from "./Top10KundenBereichDrittUmsatz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports